import { http } from "../../utils/config";

const getList = (params) => {
    const url = "/api/v1/admin/feedback-threads";
    return http.get(url, { params });
};

/**
 * @param {object} options
 *  - peek: true = CHỈ XEM, backend không đánh dấu đã đọc. Nhịp poll phải dùng cờ này, nếu không
 *    tin khách vừa gửi sẽ bị đánh "đã đọc" khi nhân sự không ngồi ở máy -> badge tắt, bỏ sót.
 *  - signal: để hủy request cũ khi đổi/đóng hội thoại (tránh phản hồi cũ ghi đè phiếu đang xem).
 */
const getDetail = (id, { peek = false, signal } = {}) => {
    const url = `/api/v1/admin/feedback-threads/${id}`;
    return http.get(url, { params: peek ? { peek: 1 } : undefined, signal });
};

/** NSX chủ động đánh dấu đã đọc (mở phiếu / bấm vào tin mới do poll mang về). */
const markRead = (id) => {
    const url = `/api/v1/admin/feedback-threads/${id}/mark-read`;
    return http.post(url);
};

const reply = (id, data) => {
    const url = `/api/v1/admin/feedback-threads/${id}/messages`;
    return http.post(url, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

const updateStatus = (id, data) => {
    const url = `/api/v1/admin/feedback-threads/${id}/status`;
    return http.put(url, data);
};

const feedbackApi = {
    getList,
    getDetail,
    markRead,
    reply,
    updateStatus,
};

export default feedbackApi;
